import { FORM_ADAPTER_TYPES } from '../constants';
import ReduxFormAdapterProvider from './ReduxFormAdapterProvider';
import RHFFormAdapterProvider from './RHFFormAdapterProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormAdapterProvider = ({
  form,
  type,
  children
}) => {
  if (type === FORM_ADAPTER_TYPES.RHF) {
    return /*#__PURE__*/_jsx(RHFFormAdapterProvider, {
      formName: form,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(ReduxFormAdapterProvider, {
    formName: form,
    children: children
  });
};
//# sourceMappingURL=FormAdapterProvider.js.map